// const link_aprovacao = 'http://localhost:3000'
// const link_aprovacao = 'http://alugmais.anvali.com.br'
const link_aprovacao = 'http://consulta.alugmais.com'

export default link_aprovacao